import type { ReactNode } from 'react';

const MARK = '\u0000';

/**
 * Renders a dictionary message that takes one value, with a React node in the value's place
 * (e.g. a document number that must stay an isolated, left-to-right element inside Arabic text).
 */
export function fillTemplate(message: (value: string) => string, node: ReactNode): ReactNode {
  const [before = '', after = ''] = message(MARK).split(MARK);
  return (
    <>
      {before}
      {node}
      {after}
    </>
  );
}
